import { addStyles, DefaultTheme } from '../components/theme';
import { T, Translate } from '../i18n';
import type { MithrilVNode } from '../mithril';
import { m } from '../mithril';
import { Services } from '../services';
import { IkePage, type IkePageConfig, IkePageName } from './page';

const CSS = {
	container: 'c-Missing',
	left: 'c-Missing__Left',
	right: 'c-Missing__Right',
	errorName: 'c-Missing__Error-Name',
	errorDescription: 'c-Missing__Error-Description',
};

const Style = {
	[CSS.container]: {
		width: '100%',
		height: '100%',
		display: 'flex',
		'justify-content': 'center',
		'align-items': 'center',
		'background-color': DefaultTheme.background.darkGrey,
	},
	[CSS.left]: {
		'justify-content': 'center',
		'align-items': 'center',
		'margin-right': DefaultTheme.space(14),
		'font-size': '112px',
		color: DefaultTheme.color.accent,
	},
	[CSS.right]: {
		color: DefaultTheme.background.offWhite,
	},
	[CSS.errorName]: {
		'font-size': DefaultTheme.space(21),
		'margin-bottom': DefaultTheme.space(12),
		'line-height': 1,
	},
	[CSS.errorDescription]: {
		'font-size': DefaultTheme.space(5),
	},
};

addStyles(Style);

export type MissingTypes = 404 | 403;

interface ErrorInfo {
	errorCode: T;
	errorTitle?: T;
	errorBeforeLink?: T;
	errorLinkText?: T;
	errorAfterLink?: T;
}

// todo: we could use Proxy once we get rid of IE :)
const MissingErrors: { [key: number]: ErrorInfo } = {
	404: {
		errorCode: T.MISSING_404_CODE,
		errorTitle: T.MISSING_404_TITLE,
		errorBeforeLink: T.MISSING_404_BEFORE_LINK,
		errorLinkText: T.MISSING_404_LINK,
		errorAfterLink: T.MISSING_404_AFTER_LINK,
	},
	403: {
		errorCode: T.MISSING_403_CODE,
		errorTitle: T.MISSING_403_TITLE,
		errorBeforeLink: T.MISSING_404_BEFORE_LINK,
		errorLinkText: T.MISSING_403_LINK,
		errorAfterLink: T.MISSING_404_AFTER_LINK,
	},
};

export const MissingPageConfig: IkePageConfig = {
	type: 'internal',
	name: IkePageName.pageMissing,
	path: '/error',
	auth: {
		required: false,
	},
	layout: { nav: false },
};

export class MissingPage extends IkePage {
	errorType: MissingTypes;

	constructor(errorType: MissingTypes = 404) {
		super(MissingPageConfig);
		this.errorType = errorType;

		// If the user is not authenticated, then we dont want to show the top bar
		if (!Services.User.isAuthenticated) {
			this.config.layout = { banner: false };
		}
	}

	get nodes(): MithrilVNode {
		return m('div', { className: CSS.container }, [
			m('div', { className: CSS.left }, Translate(MissingErrors[this.errorType].errorCode)),
			m('div', { className: CSS.right }, [
				m('div', { className: CSS.errorName }, Translate(MissingErrors[this.errorType].errorTitle)),
				m('div', { className: CSS.errorDescription }, [
					m('span', Translate(MissingErrors[this.errorType].errorBeforeLink)),
					m(
						'a',
						{ href: Services.User.isAuthenticated ? '/#/map' : '/#/login' },
						Translate(MissingErrors[this.errorType].errorLinkText)
					),
					m('span', Translate(MissingErrors[this.errorType].errorAfterLink)),
				]),
			]),
		]);
	}
}
